
// section/product.liquid (ll. 103-115)

document.addEventListener('DOMContentLoaded', function() {
    console.log("DOM loaded for script");
    
    // Hole die Daten aus dem JSON-Script
    const bundleDataElement = document.getElementById('bundle-texts-data');
    const bundleTexts = bundleDataElement ? JSON.parse(bundleDataElement.textContent) : null;
    
    if (bundleTexts) {
        console.log("Bundle Texts:", bundleTexts);
        
        let singleItem = document.querySelectorAll('.product__selectors .selector-wrapper:nth-child(4) .radio__button .radio__label')[0];
        let tripleItem = document.querySelectorAll('.product__selectors .selector-wrapper:nth-child(4) .radio__button .radio__label')[1];
        let sixPack = document.querySelectorAll('.product__selectors .selector-wrapper:nth-child(4) .radio__button .radio__label')[2];
        
        // Rest des Codes...
        document.querySelectorAll('.product__selectors .selector-wrapper:nth-child(4) .radio__button')[0].classList.add('bundle-single');
        document.querySelectorAll('.product__selectors .selector-wrapper:nth-child(4) .radio__button')[1].classList.add('bundle-trio');
        document.querySelectorAll('.product__selectors .selector-wrapper:nth-child(4) .radio__button')[2].classList.add('bundle-six');
        
        if (bundleTexts.menge_1) {
            singleItem.innerHTML += `<span class="custom__radio"></span><div class="custom__bundle-ppi">${bundleTexts.menge_1}</div>`;
        }
        if (bundleTexts.menge_2) {
            tripleItem.innerHTML += `<span class="custom__radio"></span><div class="custom__bundle-ppi">${bundleTexts.menge_2}</div>`;
        }
        if (bundleTexts.menge_3) {
            sixPack.innerHTML += `<span class="custom__radio"></span><div class="custom__bundle-ppi">${bundleTexts.menge_3}</div>`;
        }
    }
});